import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { IOidcJwtPayload } from 'ngx-mat-esign360/lib/core/model/oidc-jwt-payload.model';
import { EnvConfigService } from './env-config.service';

@Injectable({
  providedIn: 'root',
})
export class OidcAuthService {
  constructor(private keycloak: KeycloakService, private envConfig: EnvConfigService) {}

  async init(clientId: string): Promise<boolean> {
    return this.keycloak.init({
      authorizationHeaderName: 'X-BioSignAuthorization',
      config: {
        url: this.envConfig.data.oidcAuthUrl,
        realm: this.envConfig.data.oidcRealm,
        clientId,
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false,
      } /* {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      } */,
    });

    // return this.oidcConfigService.withConfig({
    //   stsServer: 'https://auth.dev.esigner360.eu/auth',
    //   redirectUrl: window.location.origin,
    //   postLogoutRedirectUri: window.location.origin,
    //   clientId: 'agent',
    //   scope: 'openid',
    //   responseType: 'code',
    //   silentRenew: true,
    //   silentRenewUrl: `${window.location.origin}/silent-renew.html`,
    //   logLevel: LogLevel.Debug,
    // });
  }

  async login(redirectUri: string): Promise<void> {
    return this.keycloak.login({
      redirectUri,
    });
  }

  async logout(redirectUri = window.location.origin): Promise<void> {
    return this.keycloak.logout(redirectUri);
  }

  getUserData(): IOidcJwtPayload {
    return this.keycloak.getKeycloakInstance().tokenParsed as IOidcJwtPayload;
  }
}
